import { connect } from 'react-redux';
import booksRequestTable from '../../components/BooksRequest/BooksRequest';
import * as booksRequestActions from '../../actions/booksRequestsTable';

const mapStateToProps = booksRequest => ({
  booksRequest: booksRequest.booksRequest,
  selectBookOrdersByDates: booksRequest.selectBookOrdersByDates,
  initialValues: booksRequest.initialValues,
});

const mapDispatchToProps = dispatch => ({
  fetchBookOrders: dates => dispatch(booksRequestActions.booksRequestsTable(dates)),
  bookRequestById: id => dispatch(booksRequestActions.booksRequestId(id)),
  deleteRequestId: id => dispatch(booksRequestActions.deleteRequestId(id)),
  addRequest: dataset => dispatch(booksRequestActions.addRequest(dataset)),
  searchBooks: (dataset, page) => dispatch(booksRequestActions.searchBooks(dataset, page)),
  addBooksToOrder: (dataset, orderId) => dispatch(booksRequestActions.addBooksToOrder(dataset, orderId)),
  removeBooksFromOrder: requestId => dispatch(booksRequestActions.removeBooksFromOrder(requestId)),
  editBooksFromOrder: (requestId, values) => dispatch(booksRequestActions.editBooksFromOrder(requestId, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(booksRequestTable);
